export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
};

export type AddEventAdditionalDetailInput = {
  displayOnPage?: InputMaybe<Scalars['Boolean']['input']>;
  eventId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AddEventAdditionalDetailResult = {
  __typename?: 'AddEventAdditionalDetailResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddPlusOnesToGuestInput = {
  plusOnes: Array<PlusOneInput>;
  primaryGuestId: Scalars['String']['input'];
};

export type AdditionalDetail = {
  __typename?: 'AdditionalDetail';
  displayOnPage: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdditionalDetailInput = {
  displayOnPage?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum AttendanceStatus {
  ATTENDING = 'ATTENDING',
  NOT_ATTENDING = 'NOT_ATTENDING',
  NO_RESPONSE = 'NO_RESPONSE'
}

export type ConfirmPaymentResult = {
  __typename?: 'ConfirmPaymentResult';
  event: Event;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateEventInput = {
  defaultInvitationDesign?: InputMaybe<Scalars['JSON']['input']>;
  eventDateTime: Scalars['Float']['input'];
  eventName: Scalars['String']['input'];
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  maxGuests?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGuestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  invitationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryGuestId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvitationInput = {
  allowedPlusOnes?: InputMaybe<Scalars['Int']['input']>;
  eventId: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  guestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  invitationTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvitationTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  designCustomizations?: InputMaybe<Scalars['JSON']['input']>;
  eventId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rsvpByDate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateResponseInput = {
  allAttending?: InputMaybe<Scalars['Boolean']['input']>;
  allDeclining?: InputMaybe<Scalars['Boolean']['input']>;
  guestAttendanceUpdates?: InputMaybe<Array<GuestAttendanceUpdateInput>>;
  invitationId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  authRef?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteEventAdditionalDetailInput = {
  eventId: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type DeleteEventAdditionalDetailResult = {
  __typename?: 'DeleteEventAdditionalDetailResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Event = {
  __typename?: 'Event';
  activityTimeline: Array<TimelineEvent>;
  additionalDetails: Array<AdditionalDetail>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Float']['output'];
  eventDateTime: Scalars['Float']['output'];
  eventName: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationTypes: Array<InvitationType>;
  invitations: Array<Invitation>;
  isPaid: Scalars['Boolean']['output'];
  maxGuests?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['Float']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Float']['output'];
};

export type EventDetails = {
  __typename?: 'EventDetails';
  eventDate?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  rawExtractedData?: Maybe<Scalars['JSON']['output']>;
};

export type EventPayment = {
  __typename?: 'EventPayment';
  clientSecret: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  eventId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Float']['output']>;
  failedAt?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  originalMaxGuests?: Maybe<Scalars['Int']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  productCode: Scalars['String']['output'];
  status: PaymentStatus;
  updatedAt: Scalars['Float']['output'];
};

export type EventViewLog = {
  __typename?: 'EventViewLog';
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  viewSource: Scalars['String']['output'];
  viewedAt: Scalars['Float']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  attendance: AttendanceStatus;
  createdAt: Scalars['Float']['output'];
  dietaryRequirements?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  event: Event;
  eventId: Scalars['String']['output'];
  guestNumber: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invitation?: Maybe<Invitation>;
  invitationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  primaryGuestId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Float']['output'];
};

export type GuestAttendanceUpdateInput = {
  attendance: AttendanceStatus;
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>;
  guestId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  activityTimeline: Array<TimelineEvent>;
  allowedPlusOnes: Scalars['Int']['output'];
  createdAt: Scalars['Float']['output'];
  event: Event;
  eventId: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  guests: Array<Guest>;
  id: Scalars['ID']['output'];
  invitationType: InvitationType;
  invitationTypeId: Scalars['String']['output'];
  responses: Array<Response>;
  token: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export type InvitationAccessLog = {
  __typename?: 'InvitationAccessLog';
  accessedAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invitationId: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvitationPage = {
  __typename?: 'InvitationPage';
  design: Scalars['JSON']['output'];
  event: Event;
  invitation: Invitation;
  invitationType: InvitationType;
  rsvpDate: Scalars['Float']['output'];
};

export type InvitationType = {
  __typename?: 'InvitationType';
  createdAt: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designCustomizations?: Maybe<Scalars['JSON']['output']>;
  event: Event;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rsvpByDate?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Float']['output'];
};

export type LogEventViewInput = {
  eventId: Scalars['String']['input'];
  viewSource: Scalars['String']['input'];
};

export type LogEventViewResult = {
  __typename?: 'LogEventViewResult';
  eventViewLog: EventViewLog;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addEventAdditionalDetail: AddEventAdditionalDetailResult;
  addPlusOnesToGuest: Array<Guest>;
  confirmPaymentSuccess: ConfirmPaymentResult;
  createEvent: Event;
  createGuest: Guest;
  createInvitation: Invitation;
  createInvitationType: InvitationType;
  createPaymentIntent: PaymentIntent;
  createResponse: Response;
  createUser: User;
  deleteEventAdditionalDetail: DeleteEventAdditionalDetailResult;
  deleteGuest: Scalars['Boolean']['output'];
  deleteInvitationType: Scalars['Boolean']['output'];
  logEventView: LogEventViewResult;
  saveInvitationTypeDesign: InvitationType;
  sendInvitation: SendInvitationResult;
  setEventAdditionalDetails: SetEventAdditionalDetailsResult;
  setSystemConfiguration: SystemConfiguration;
  submitPublicResponse: Response;
  updateEvent: Event;
  updateEventAdditionalDetail: UpdateEventAdditionalDetailResult;
  updateGuest: Guest;
  updateInvitationType: InvitationType;
};


export type MutationAddEventAdditionalDetailArgs = {
  input: AddEventAdditionalDetailInput;
};


export type MutationAddPlusOnesToGuestArgs = {
  input: AddPlusOnesToGuestInput;
};


export type MutationConfirmPaymentSuccessArgs = {
  eventId: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateGuestArgs = {
  input: CreateGuestInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateInvitationTypeArgs = {
  input: CreateInvitationTypeInput;
};


export type MutationCreatePaymentIntentArgs = {
  eventId: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationCreateResponseArgs = {
  input: CreateResponseInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteEventAdditionalDetailArgs = {
  input: DeleteEventAdditionalDetailInput;
};


export type MutationDeleteGuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvitationTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLogEventViewArgs = {
  input: LogEventViewInput;
};


export type MutationSaveInvitationTypeDesignArgs = {
  input: SaveInvitationTypeDesignInput;
};


export type MutationSendInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationSetEventAdditionalDetailsArgs = {
  input: SetEventAdditionalDetailsInput;
};


export type MutationSetSystemConfigurationArgs = {
  input: SetSystemConfigurationInput;
};


export type MutationSubmitPublicResponseArgs = {
  input: PublicCreateResponseInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateEventAdditionalDetailArgs = {
  input: UpdateEventAdditionalDetailInput;
};


export type MutationUpdateGuestArgs = {
  input: UpdateGuestInput;
};


export type MutationUpdateInvitationTypeArgs = {
  input: UpdateInvitationTypeInput;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  clientSecret: Scalars['String']['output'];
};

export enum PaymentStatus {
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type PlusOneInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PriceDetails = {
  __typename?: 'PriceDetails';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  priceId: Scalars['String']['output'];
};

export type PublicCreateResponseInput = {
  allAttending?: InputMaybe<Scalars['Boolean']['input']>;
  allDeclining?: InputMaybe<Scalars['Boolean']['input']>;
  eventCode: Scalars['String']['input'];
  guestAttendanceUpdates?: InputMaybe<Array<GuestAttendanceUpdateInput>>;
  invitationToken: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<User>;
  event?: Maybe<Event>;
  events: Array<Event>;
  getEventAdditionalDetails: SetEventAdditionalDetailsResult;
  getPaymentStatus?: Maybe<EventPayment>;
  getPriceDetails: PriceDetails;
  getSystemConfiguration?: Maybe<SystemConfiguration>;
  guestsByEvent: Array<Guest>;
  guestsByEventAndStatus: Array<Guest>;
  guestsByInvitation: Array<Guest>;
  invitationAccessLogsByEvent: Array<InvitationAccessLog>;
  invitationByToken?: Maybe<InvitationPage>;
  invitationType?: Maybe<InvitationType>;
  invitationTypes: Array<InvitationType>;
  invitationTypesByEvent: Array<InvitationType>;
  parseEventDetailsFromDesign: EventDetails;
  responses: Array<Response>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEventAdditionalDetailsArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGetPaymentStatusArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGetPriceDetailsArgs = {
  productCode: Scalars['String']['input'];
};


export type QueryGetSystemConfigurationArgs = {
  key: Scalars['String']['input'];
};


export type QueryGuestsByEventArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGuestsByEventAndStatusArgs = {
  eventId: Scalars['String']['input'];
  status?: InputMaybe<AttendanceStatus>;
};


export type QueryGuestsByInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type QueryInvitationAccessLogsByEventArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryInvitationByTokenArgs = {
  eventCode: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryInvitationTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvitationTypesByEventArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryParseEventDetailsFromDesignArgs = {
  customizations: Scalars['JSON']['input'];
};

export type Response = {
  __typename?: 'Response';
  createdAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invitation: Invitation;
  invitationId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Float']['output'];
};

export type SaveInvitationTypeDesignInput = {
  customizations: Scalars['JSON']['input'];
  invitationTypeId: Scalars['ID']['input'];
};

export type SendInvitationResult = {
  __typename?: 'SendInvitationResult';
  invitationId: Scalars['String']['output'];
  sentToGuests: Array<SentToGuest>;
};

export type SentToGuest = {
  __typename?: 'SentToGuest';
  deliveryMethod: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  guestId: Scalars['String']['output'];
  guestName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetEventAdditionalDetailsInput = {
  additionalDetails: Array<AdditionalDetailInput>;
  eventId: Scalars['String']['input'];
};

export type SetEventAdditionalDetailsResult = {
  __typename?: 'SetEventAdditionalDetailsResult';
  additionalDetails: Array<AdditionalDetail>;
  eventId: Scalars['String']['output'];
};

export type SetSystemConfigurationInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  createdAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  data: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type UpdateEventAdditionalDetailInput = {
  displayOnPage?: InputMaybe<Scalars['Boolean']['input']>;
  eventId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateEventAdditionalDetailResult = {
  __typename?: 'UpdateEventAdditionalDetailResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateEventInput = {
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateGuestInput = {
  attendance?: InputMaybe<AttendanceStatus>;
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvitationInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateInvitationTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  designCustomizations?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rsvpByDate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateResponseInput = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  authRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};
